import React from 'react';

const Loader = () => {
    return (
        <div className="loader">
            <div className="typing_loader"></div>
        </div>
    )
};

export default Loader;